export default class UtilityFunctions {
	static sortAlphabetically(arr) {
		if (!arr) return;
		arr.sort((a, b) => {
			if (a.title > b.title) return 1;
			if (a.title < b.title) return -1;
			if ((a.title = b.title)) return 0;
		});
		return arr;
	}
	static buildArticleTree(articles) {
		let hashTable = Object.create(null);

		articles.forEach(a => hashTable[a.id] = { ...a, children: [] });

		let articleTree = [];

		articles.forEach(a => {
			if (a.parentArticleId) {
				hashTable[a.parentArticleId].children.push(hashTable[a.id]);
			} else {
				articleTree.push(hashTable[a.id]);
			}
		});

		return articleTree;
	}
	static calcTreeLength(tree) {
		if (!tree) return;
		let num = tree.length;
		tree.forEach(t => {
			num += this.calcTreeLength(t.children);
		})
		return num;
	}

	static normalizeType(type) {
		type = type.toLowerCase();
		type = type.split("_").join(" ");
		type = type.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
		return type;
	}

	static findInTree(id, tree) {
		if (!id || !tree) return;
		let found;
		for (let i = 0; i < tree.length; i++) {
			const el = tree[i];
			let stack = [];
			let node;
			stack.push(el);
			while (stack.length > 0) {
				node = stack.pop();
				if (node.id == id) {
					found = node;
					break;
				} else if (node.children && node.children.length) {
					stack.push(...node.children);
				}
			}
			if(found) {
				break;
			}
		}
		
		return found;
	}
}